import { useCurrentBreakpoint } from "./media/index.js";
const BREAKPOINT_ORDER = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const useResponsiveColumnWidths = (config)=>{
    const current = useCurrentBreakpoint();
    const currentIndex = BREAKPOINT_ORDER.indexOf(current);
    for(let i = currentIndex; i >= 0; i--){
        const bp = BREAKPOINT_ORDER[i];
        if (config[bp]) return config[bp];
    }
    for(let i = 0; i < BREAKPOINT_ORDER.length; i++){
        const bp = BREAKPOINT_ORDER[i];
        if (config[bp]) return config[bp];
    }
    return {};
};
export { useResponsiveColumnWidths };
